/**
 * TAI TEP VE MAY.
 *
 * Tach rieng khoi App vi bay gio co BA duong tai ve: luu ca tai lieu, trich
 * xuat trang da chon, va tach thanh tung trang roi. Ba ban sao cua cung mot
 * doan ma se troi khoi nhau - va cai troi truoc tien luon la viec dat ten tep.
 */

/**
 * Ten tep an toan tren Windows.
 *
 * Giu nguyen dau tieng Viet (NTFS luu ten dang UTF-16, "Hợp đồng thuê nhà.pdf"
 * hoan toan hop le) nhung phai loai:
 *   - cac ky tu Windows cam: \ / : * ? " < > |
 *   - ky tu dieu khien
 *   - dau cach / dau cham o CUOI ten: Explorer am tham cat bo, sinh ra ten khac
 *     voi ten ta yeu cau
 *   - cac ten thiet bi dat truoc: CON, PRN, AUX, NUL, COM1..9, LPT1..9
 */
export function safeFileName(name: string): string {
  // Ky tu Windows cam. Dau cach VAN GIU: "Hop dong 2026.pdf" la ten hop le.
  // Ky tu dieu khien duoc loc bang ma diem, khong bang regex - de khong bao gio
  // co byte NUL that nam trong ma nguon nay.
  let out = Array.from(name)
    .filter((c) => (c.codePointAt(0) ?? 0) >= 0x20)
    .join('')
    .replace(/[\\/:*?"<>|]/g, '_');
  out = out.replace(/[ .]+$/, '');
  if (/^(con|prn|aux|nul|com[1-9]|lpt[1-9])$/i.test(out)) out = `_${out}`;
  if (out.length === 0) out = 'tai-lieu';
  // Gioi han do dai de con cho duong dan thu muc (MAX_PATH 260 tren Windows).
  return out.length > 150 ? out.slice(0, 150) : out;
}

/** Bo duoi .pdf va lam sach ten goc, de ghep hau to vao. */
export function baseNameOf(sourceName: string | null): string {
  return safeFileName((sourceName ?? 'tai-lieu').replace(/\.pdf$/i, ''));
}

export function downloadPdfBytes(bytes: Uint8Array, fileName: string): void {
  const blob = new Blob([bytes as unknown as BlobPart], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
  a.rel = 'noopener';
  // Phai NAM TRONG tai lieu truoc khi click: mot so trinh duyet bo qua click()
  // tren the <a> chua gan vao DOM.
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Thu hoi URL NGAY LAP TUC se huy lan tai xuong dang bat dau - no khong dong
  // bo. Cho mot nhip roi moi thu hoi, nhung PHAI thu hoi: moi lan luu giu lai
  // ca tep trong bo nho cho den khi dong tab.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
